/**
 * Khớp tên danh mục món/đồ uống từ API/DB (tên mới "ăn uống", còn tên cũ "địa phương"/"local").
 */
export function isFoodCategoryDisplayName(name) {
  const n = String(name || "").trim().toLowerCase();
  return (
    n === "ăn uống" ||
    n === "ẩm thực địa phương" ||
    n === "ẩm thực local"
  );
}
